import { render } from "./menuList.vue?vue&type=template&id=b4e24ab6&scoped=true"
import script from "./menuList.vue?vue&type=script&lang=js"
export * from "./menuList.vue?vue&type=script&lang=js"

import "./menuList.vue?vue&type=style&index=0&id=b4e24ab6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e24ab6"]])

export default __exports__